// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2yBuq","label":"LabeledBox_label__11j0x"};